/** Whether a row's label, hint or keywords contain every word typed, any case.
 *  The phone's More page filters with it (routes/More.tsx). */
export function matches(
  row: { label: string; hint?: string; keywords?: string },
  query: string,
): boolean {
  const hay = `${row.label} ${row.hint ?? ""} ${row.keywords ?? ""}`.toLowerCase();
  return query
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => hay.includes(word));
}
